function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _class2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Component, register } from 'ovee.js';
import gsap from 'gsap';

var _class = (_dec = register('filters-trigger'), _dec(_class2 = /*#__PURE__*/function (_Component) {
  _inherits(_class2, _Component);

  var _super = _createSuper(_class2);

  function _class2() {
    _classCallCheck(this, _class2);

    return _super.apply(this, arguments);
  }

  _createClass(_class2, [{
    key: "init",
    value: function init() {
      this.options = this.getOptions();
      this.classHandler = this.classHandler.bind(this);
      this.categories = document.querySelector('.categories');
      this.bind();
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var speed = 0.3;
      var ease = 'none';
      return {
        speed: speed,
        ease: ease
      };
    }
  }, {
    key: "classHandler",
    value: function classHandler() {
      var _this = this;

      if (this.isMobile) {
        this.$element.classList.toggle('is-active');

        if (this.categories.style.height !== '0px' && this.categories.style.height) {
          gsap.to(this.categories, {
            duration: this.options.speed,
            ease: this.options.ease,
            height: 0,
            onComplete: function onComplete() {
              _this.categories.classList.remove('is-visible');
            }
          });
        } else {
          gsap.to(this.categories, {
            duration: this.options.speed,
            ease: this.options.ease,
            height: "".concat(this.categories.scrollHeight, "px"),
            className: 'categories is-visible'
          });
        }
      }
    }
  }, {
    key: "bind",
    value: function bind() {
      this.$element.addEventListener('click', this.classHandler);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.$element.removeEventListener('click', this.classHandler);
    }
  }, {
    key: "isMobile",
    get: function get() {
      return window.matchMedia('(max-width: 1024px)').matches;
    }
  }]);

  return _class2;
}(Component)) || _class2);

export { _class as default };